import { render, staticRenderFns } from "./siteDettails.vue?vue&type=template&id=63ca33a8&"
import script from "./siteDettails.vue?vue&type=script&lang=js&"
export * from "./siteDettails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports